import React, { useState } from 'react';

export type BreadcrumbsActionsContextType = {
  actions: JSX.Element | React.ReactNode | Element | null;
  updateActions: (actions: JSX.Element | React.ReactNode | Element | null) => void;
};

export const BreadcrumbsActionsContext = React.createContext<BreadcrumbsActionsContextType>({
  actions: null,
  updateActions: () => void 0,
});

export const BreadcrumbsActionsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [actions, setActions] = useState<JSX.Element | React.ReactNode | Element | null>(null);
  const updateActions = (actions: JSX.Element | React.ReactNode | Element | null) => {
    setActions(actions);
  };

  return (
    <BreadcrumbsActionsContext.Provider value={{ actions, updateActions }}>
      {children}
    </BreadcrumbsActionsContext.Provider>
  );
};
